'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _footerLinks = require('./footerLinks');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_footerLinks).default;
  }
});

var _model = require('./model');

Object.defineProperty(exports, 'FooterLinkRecord', {
  enumerable: true,
  get: function get() {
    return _model.FooterLink;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/footer-links/index.js
// module id = 446
// module chunks = 0